export const BULK_SELECTABLE_STATUSES = ["READY", "APPROVED"];

const INDETERMINATE_STATUSES = [
  "DENIED",
  "INCOMPLETE",
  "PENDING",
  "ECHECKPENDING",
  "CASHPENDING",
];

export const normalizeStatus = (confirmationStatus) =>
  (confirmationStatus || "").toUpperCase();

export const isBulkSelectable = (confirmationStatus) =>
  BULK_SELECTABLE_STATUSES.includes(normalizeStatus(confirmationStatus));

export const getApprovedTransactionIds = (transactionList) =>
  (transactionList || [])
    .filter(
      (transaction) =>
        normalizeStatus(transaction.confirmationStatus) === "APPROVED"
    )
    .map((transaction) => transaction.transactionId);

export const getSelectableTransactionIds = (transactionList) =>
  (transactionList || [])
    .filter((transaction) => isBulkSelectable(transaction.confirmationStatus))
    .map((transaction) => transaction.transactionId);

export const areAllSelectableChecked = (transactionList, checkedIds) => {
  const selectableIds = getSelectableTransactionIds(transactionList);
  const checked = checkedIds || [];
  return (
    selectableIds.length > 0 &&
    selectableIds.every((id) => checked.includes(id))
  );
};

export const syncCheckedIdsWithPage = (
  transactionList,
  checkedIds,
  seedApproved,
  excludedApprovedIds
) => {
  const visibleIds = new Set(
    (transactionList || []).map((transaction) => transaction.transactionId)
  );
  const selectableIdSet = new Set(getSelectableTransactionIds(transactionList));
  const excluded = excludedApprovedIds || new Set();

  let nextIds = (checkedIds || []).filter(
    (id) => visibleIds.has(id) && selectableIdSet.has(id)
  );

  if (seedApproved) {
    getApprovedTransactionIds(transactionList).forEach((id) => {
      if (!nextIds.includes(id) && !excluded.has(id)) {
        nextIds.push(id);
      }
    });
  }

  return nextIds;
};

export const getSummaryCheckboxPresentation = (
  confirmationStatus,
  isInRowsChecked
) => {
  const status = normalizeStatus(confirmationStatus);

  if (status === "PAID") {
    return {
      checked: true,
      disabled: true,
      indeterminate: false,
      selectable: false,
    };
  }

  if (INDETERMINATE_STATUSES.includes(status)) {
    return {
      checked: false,
      disabled: true,
      indeterminate: true,
      selectable: false,
    };
  }

  if (status === "READY" || status === "APPROVED") {
    return {
      checked: isInRowsChecked,
      disabled: false,
      indeterminate: false,
      selectable: true,
    };
  }

  return {
    checked: false,
    disabled: true,
    indeterminate: false,
    selectable: false,
  };
};
